import { ResolveFn, Router } from '@angular/router';
import { QuotationService } from '../services/quotation/quotation.service';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QuotationRFPDetails } from '../models/quotation-rfp';
import { forkJoin, tap } from 'rxjs';
import { RFQGroup } from '../models/rfq';
import { ApiResponse } from '../Interfaces/apiResponse.interface';
import { NavigationPipe } from '../pipes/navigation/navigation.pipe';
import { Path } from '../constants/paths.constant';
import { QuotationRFPService } from '../services/quotation-rfp/quotation-rfp.service';
import { RfpService } from '../services/rfp/rfp.service';
import { ReceivedRfpService } from '../services/received-rfp/received-rfp.service';

interface QuotationRFPDetailsResolvedData {
  details: ApiResponse<QuotationRFPDetails>;
  groups: ApiResponse<RFQGroup[]>;
}

export const quotationRFPDetailsResolver: ResolveFn<
  QuotationRFPDetailsResolvedData
> = (route, state) => {
  const router = inject(Router);
  const receivedRfpService = inject(ReceivedRfpService);
  const navigation = new NavigationPipe();
  const quotationRFPService = inject(QuotationRFPService);
  const destroyRef = inject(DestroyRef);
  const rfpId = route.params['rfpId'];
  const quotationId = route.params['quotationId'];
  const isBuyer = state.url.includes('buyer');

  return forkJoin({
    details: isBuyer
      ? quotationRFPService.getBuyerQuotationDetails(rfpId, quotationId)
      : quotationRFPService.getContractorQuotationDetails(rfpId, quotationId),
    groups: isBuyer
      ? quotationRFPService.getBuyerQuotationDetailsGroups(rfpId, quotationId)
      : receivedRfpService.getReceivedRfpGroups(rfpId),
  }).pipe(
    takeUntilDestroyed(destroyRef),
    tap(({ details, groups }) => {
      if (!details.data || !groups.data)
        router.navigate([
          navigation.transform(
            isBuyer
              ? `${Path.BUYER}/${Path.QUOTATION.QUOTATION_RFP}`
              : `${Path.CONTRACTOR}/${Path.QUOTATION.QUOTATION_RFP}`
          ),
        ]);
    })
  );
};
